export default class LimitsUsageAbstractServices {
  static getReferenceData() {
    logger.error('LimitsUsage:: getReferenceData() not implemented');
  }

  static retrieveLimitsAndUsage() {
    logger.error('LimitsUsage:: retrieveLimitsAndUsage() not implemented');
  }

  static retrieveReplacementPeriods() {
    logger.error('LimitsUsage:: retrieveReplacementPeriods() not implemented');
  }

  static getMemberHistory() {
    logger.error('LimitsUsage:: getMemberHistory() not implemented');
  }

  static retrieveServicesAndLimits() {
    logger.error('LimitsUsage:: retrieveServicesAndLimits() not implemented');
  }
}
